export default __webpack_public_path__ + "static/media/Select.2517e1dc.svg";